import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

async function callBillingCallable(name, payload) {
  const fn = httpsCallable(functions, name);
  const response = await fn(payload);
  return response?.data?.data ?? response?.data ?? null;
}

export function getBillingOverview(fleetId) {
  return callBillingCallable("get_billing_overview", { fleetId });
}
export function requestEDocPackage(fleetId, request) {
  return callBillingCallable('request_edoc_package', { fleetId, ...request });
}

export function updateBillingProfile(fleetId, profile) {
  return callBillingCallable("update_billing_profile", { fleetId, ...profile });
}

export function startBillingTrial(fleetId) {
  return callBillingCallable("start_billing_trial", { fleetId });
}

export function changeBillingSelection(fleetId, selection) {
  return callBillingCallable("change_billing_selection", { fleetId, ...selection });
}

export function createBillingCheckoutSession(fleetId) {
  return callBillingCallable("create_billing_checkout_session", { fleetId });
}

export function createBillingPortalSession(fleetId) {
  return callBillingCallable("create_billing_portal_session", { fleetId });
}
